import "./styles.css";
import { InMemoryDatabase } from "brackets-memory-db";
import { BracketsManager } from "@repo/brackets-manager";
import { BracketsViewer } from "./main.js";

window.bracketsViewer = new BracketsViewer();
window.inMemoryDatabase = new InMemoryDatabase();
window.bracketsManager = new BracketsManager(window.inMemoryDatabase);

export { BracketsViewer };
export * from "./types.js";
